import {IController} from "angular";
import './loader.scss';

interface LoaderScope {
    showLoader: boolean;
}



export class Loader implements IController {
    private $scope: LoaderScope;

    static instance = {
        template: require('./loader.html'),
        controller: ['$scope', 'LoaderStatusValue', Loader]
    };

    constructor($scope: LoaderScope, LoaderStatusValue) {
        this.$scope = Object.assign($scope, {showLoader: false});
    }


}